import {create} from 'zustand';
import {immer} from 'zustand/middleware/immer';

type EntryErrorStore = {
    company_name: string;
    your_name: string;
    email: string;
    tel: string;
    project_detail_section: string;
    yoto_naiyo1: string;
    yoto_menseki1: string;
    shinsakikan_sinseitaio: string;
    mitsumori_iraijino_kibonoki: string;
    files: string;
    agree: string;

    reset: () => void;
    setValue: (name: string, value: string) => void;
    getValues: () => { [key: string]: string }
}



export const createDefaultParams = () => {
    return {
        company_name: '',
        your_name: '',
        email: '',
        tel: '',
        project_detail_section: '',
        yoto_naiyo1: '',
        yoto_menseki1: '',
        shinsakikan_sinseitaio: '',
        mitsumori_iraijino_kibonoki: '',
        files: '',
        agree: '',
    }
}

export const useEntryErrorStore = create<EntryErrorStore>()(
    immer(
        (set, get) => ({
                ...createDefaultParams(),

                reset: () => {
                    set((state) => {
                        const defaults = createDefaultParams();
                        state.company_name = defaults.company_name;
                        state.your_name = defaults.your_name;
                        state.email = defaults.email;
                        state.tel = defaults.tel;
                        state.project_detail_section = defaults.project_detail_section;
                        state.yoto_naiyo1 = defaults.yoto_naiyo1;
                        state.yoto_menseki1 = defaults.yoto_menseki1;
                        state.shinsakikan_sinseitaio = defaults.shinsakikan_sinseitaio;
                        state.mitsumori_iraijino_kibonoki = defaults.mitsumori_iraijino_kibonoki;
                        state.files = defaults.files;
                        state.agree = defaults.agree;
                    })
                },

                setValue: (name: string, value: string) => {
                    set((state) => {
                        state[name] = value;
                    })
                },
                getValues: () => {

                    return {
                        company_name: get().company_name,
                        your_name: get().your_name,
                        email: get().email,
                        tel: get().tel,
                        project_detail_section: get().project_detail_section,
                        yoto_naiyo1: get().yoto_naiyo1,
                        yoto_menseki1: get().yoto_menseki1,
                        shinsakikan_sinseitaio: get().shinsakikan_sinseitaio,
                        mitsumori_iraijino_kibonoki: get().mitsumori_iraijino_kibonoki,
                        files: get().files,
                        agree: get().agree,
                    };
                }

            }
        ))
)
